
import React from "react";



const Movies = ({ poster_path, title, vote_average, overview }) => {
    return (
        <div className="md:col-4 col-12 py-8">
            <div className="transition duration-200 h-full ease-in-out hover:-translate-y-2 bg-white rounded-xl my-4 overflow-hidden drop-shadow-2xl w-10/12">
                <img className="w-full object-cover max-h-96" src={"https://image.tmdb.org/t/p/original/" + poster_path} alt="" />
                <div className="px-4">
                    <h1 className="text-3xl my-3 text-gray-600 font-medium">{title}</h1>
                    <div className="flex items-center justify-start">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="gray">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                        </svg>
                        <h1 className="my-3 text-gray-500 text-md pl-2">{vote_average} / 10</h1>
                    </div>
                    <h1 className="text-lg text-gray-500 my-3 line-clamp-3">{overview}</h1>
                </div>
            </div>
        </div>
    );
}

export default Movies;